import * as PrimitiveRadixDialog from '@radix-ui/react-dialog';
import { ForwardedRef } from 'react';

export interface SheetCloseProps extends PrimitiveRadixDialog.DialogCloseProps {}

export function SheetClose(props: SheetCloseProps, ref: ForwardedRef<HTMLButtonElement>): JSX.Element {
	return <PrimitiveRadixDialog.Close {...props} ref={ref} />;
}
